const TaskList = [
    {
        ID: 1,
        title: "Building Tech Support Solution",
        assignedto: 'Oduyemi Obaloluwa',
        assignedby: 'Segun Taiwo',
        discription: 'You are expected to design the detailed onboarding application for newbies in the department, given the discription below, follow the details carefully and represent the design as stated. \nEnsure you keep to the project time line and stated in the project details',
        start: "Fri Apr 04 2022",
        stop: "Fri Apr 04 2022",
        categroy: "personal",
        participants: [
            {
                imgurl: "/assets/img2.png",
                name: "Alison Oba",
                livestatus: "offline",
            },
            {
                imgurl: "/assets/img2.png",
                name: "Segun Taiwo",
                livestatus: "online",
            },
            {
                imgurl: "/assets/img3.png",
                name: "Damilola Awosope",
                livestatus: "offline",
            },
            {
                imgurl: "/assets/img2.png",
                name: "Alison Oba",
                livestatus: "offline",
            },
            {
                imgurl: "/assets/img2.png",
                name: "Segun Taiwo",
                livestatus: "online",
            },
            {
                imgurl: "/assets/img3.png",
                name: "Damilola Awosope",
                livestatus: "online",
            },
        ],
        discussion: [
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
        ]
    },
    {
        ID: 2,
        title: "Building Tech Support Solution",
        assignedto: 'Akindele Tunde',
        assignedby: 'Bolaji Oladipo',
        discription: 'You are expected to design the detailed onboarding application for newbies in the department, given the discription below, follow the details carefully and represent the design as stated. \nEnsure you keep to the project time line and stated in the project details',
        start: "Fri Apr 04 2022",
        stop: "Fri Apr 04 2022",
        categroy: "personal",
        participants: [
            {
                imgurl: "/assets/img2.png",
                name: "Alison Oba",
                livestatus: "offline",
            },
            {
                imgurl: "/assets/img2.png",
                name: "Segun Taiwo",
                livestatus: "offline",
            },
            {
                imgurl: "/assets/img3.png",
                name: "Bolaji Oladipo",
                livestatus: "offline",
            },
            {
                imgurl: "/assets/img5.png",
                name: "Odebunmi Timothy",
                livestatus: "online",
            }
        ],
        discussion: [
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
        ]
    },
    {
        ID: 3,
        title: "Building Tech Support Solution",
        assignedto: 'Bolaji Oladipo',
        assignedby: 'Segun Taiwo',
        discription: 'You are expected to design the detailed onboarding application for newbies in the department, given the discription below, follow the details carefully and represent the design as stated. \nEnsure you keep to the project time line and stated in the project details',
        start: "Fri Apr 04 2022",
        stop: "Fri Apr 04 2022",
        categroy: "personal",
        participants: [
            {
                imgurl: "/assets/img2.png",
                name: "Segun Taiwo",
                livestatus: "offline",
            },
            {
                imgurl: "/assets/img3.png",
                name: "Bolaji Oladipo",
                livestatus: "online",
            },
            {
                imgurl: "/assets/img3.png",
                name: "Damilola Awosope",
                livestatus: "online",
            },
            {
                imgurl: "/assets/img5.png",
                name: "Odebunmi Timothy",
                livestatus: "offline",
            }
        ],
        discussion: [
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
        ]
    },
    {
        ID: 4,
        title: "Building Tech Support Solution",
        assignedto: 'Akindele Tunde',
        assignedby: 'Segun Taiwo',
        discription: 'You are expected to design the detailed onboarding application for newbies in the department, given the discription below, follow the details carefully and represent the design as stated. \nEnsure you keep to the project time line and stated in the project details',
        start: "Fri Apr 04 2022",
        stop: "Fri Apr 04 2022",
        categroy: "personal",
        participants: [
            {
                imgurl: "/assets/img2.png",
                name: "Segun Taiwo",
                livestatus: "offline",
            },
            {
                imgurl: "/assets/img3.png",
                name: "Damilola Awosope",
                livestatus: "online",
            },
            {
                imgurl: "/assets/img5.png",
                name: "Odebunmi Timothy",
                livestatus: "online",
            }
        ],
        discussion: [
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
        ]
    },
    {
        ID: 5,
        title: "Building Tech Support Solution",
        assignedto: 'Awosope Damilola',
        assignedby: 'Segun Taiwo',
        discription: 'You are expected to design the detailed onboarding application for newbies in the department, given the discription below, follow the details carefully and represent the design as stated. \nEnsure you keep to the project time line and stated in the project details',
        start: "Fri Apr 04 2022",
        stop: "Fri Apr 04 2022",
        categroy: "personal",
        participants: [
            {
                imgurl: "/assets/img2.png",
                name: "Segun Taiwo",
                livestatus: "online",
            },
            {
                imgurl: "/assets/img3.png",
                name: "Bolaji Oladipo",
                livestatus: "offline",
            },
            {
                imgurl: "/assets/img3.png",
                name: "Damilola Awosope",
                livestatus: "offline",
            },
            {
                imgurl: "/assets/img5.png",
                name: "Odebunmi Timothy",
                livestatus: "online",
            },
            {
                imgurl: "/assets/img3.png",
                name: "Alison Oba",
                livestatus: "online",
            }
        ],
        discussion: [
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
        ]
    },
    {
        ID: 6,
        title: "Building Tech Support Solution",
        assignedto: 'Oduyemi Obaloluwa',
        assignedby: 'Segun Taiwo',
        discription: 'You are expected to design the detailed onboarding application for newbies in the department, given the discription below, follow the details carefully and represent the design as stated. \nEnsure you keep to the project time line and stated in the project details',
        start: "Fri Apr 04 2022",
        stop: "Fri Apr 04 2022",
        categroy: "personal",
        participants: [
            {
                imgurl: "/assets/img2.png",
                name: "Segun Taiwo",
                livestatus: "offline",
            },
            {
                imgurl: "/assets/img3.png",
                name: "Bolaji Oladipo",
                livestatus: "online",
            },
            {
                imgurl: "/assets/img3.png",
                name: "Damilola Awosope",
                livestatus: "online",
            },
            {
                imgurl: "/assets/img5.png",
                name: "Odebunmi Timothy",
                livestatus: "offline",
            }
        ],
        discussion: [
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Bolaji',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Segun',
                comment: 'Add image to the Side View of the dashboard'
            },
            {
                name: 'Obaloluwa',
                comment: 'Add image to the Side View of the dashboard'
            },
        ]
    },
]

export default TaskList